module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section07_03_american-village-11f0a50edc9701be7207fa3c911a36ab.jpg";